export default {
  title: 'Bon tipărit',
  form: {
    is_service_fee_hidden_on_receipt: {
      label: 'Ascunde taxa de serviciu pe bon',
    },
    is_price_section_hidden_on_receipt: {
      label: 'Ascunde secțiunea de prețuri pe bon',
    },
    is_modifier_group_hidden_on_receipt: {
      label: 'Ascunde numele grupurilor de modificatori pe bon',
    },
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    failed_to_save_changes: 'Nu s-au putut salva modificările',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
